module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "normalWidth": "800px",
      "set-class": "no-padding"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('Vimeo', {
    attrs: {
      "url": _vm.params.url
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc588cd2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MovieModal.vue
// module id = 1001
// module chunks = 0